{
  "INBOX_MGMT": {
    "HEADER": "Iesūtnes",
    "DESCRIPTION": "Kanāls ir saziņas veids, ko klients izvēlas saziņai ar jums. Iesūtne ir vieta, kur pārvaldāt mijiedarbības ar noteiktu kanālu. Tas var ietvert saziņu no dažādiem avotiem, piemēram, e-pasta, tiešsaistes tērzēšanas un sociālajiem medijiem.",
    "LEARN_MORE": "Uzzināt vairāk par iesūtnēm",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Jūsu iesūtne ir atvienota. Jūs nesaņemsiet jaunus ziņojumus, kamēr nebūsiet tos atkārtoti autorizējis.",
    "CLICK_TO_RECONNECT": "Noklikšķiniet šeit, lai atkārtoti izveidotu savienojumu.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "Šim kontam nav pievienota neviena Iesūtne."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Izvēlieties Kanālu",
        "BODY": "Izvēlieties pakalpojumu sniedzēju, kuru vēlaties integrēt ar Chatwoot."
      },
      "INBOX": {
        "TITLE": "Izveidot Iesūtni",
        "BODY": "Autentificēt savu kontu un izveidot iesūtni."
      },
      "AGENT": {
        "TITLE": "Pievienot Aģentus",
        "BODY": "Pievienojiet aģentus izveidotajai iesūtnei."
      },
      "FINISH": {
        "TITLE": "Gatavs!",
        "BODY": "Jūs varat sākt darboties!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Iesūtnes Nosaukums",
        "PLACEHOLDER": "Ievadiet Jūsu iesūtnes nosaukumu (piemēram: Acme Inc)",
        "ERROR": "Lūdzu, ievadiet derīgu iesūtnes nosaukumu"
      },
      "WEBSITE_NAME": {
        "LABEL": "Tīmekļa Vietnes Nosaukums",
        "PLACEHOLDER": "Ievadiet Jūsu tīmekļa vietnes nosaukumu (piemēram: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: Pierakstoties mēs iegūstam piekļuvi tikai pie Jūsu lapas ziņojumiem. Chatwoot nekad nevar piekļūt jūsu privātajām ziņām.",
        "CHOOSE_PAGE": "Izvēlieties Lapu",
        "CHOOSE_PLACEHOLDER": "Izvēlieties lapu no saraksta",
        "INBOX_NAME": "Iesūtnes Nosaukums",
        "ADD_NAME": "Pievienojiet savas iesūtnes nosaukumu",
        "PICK_NAME": "Lūdzu ievadiet Iesūtnes nosaukumu",
        "PICK_A_VALUE": "Izvēlieties vērtību",
        "CREATE_INBOX": "Izveidot Iesūtni"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Turpināt ar Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Pievienot savu Instagram Profilu",
        "HELP": "Lai pievienotu savu Instagram profilu kā kanālu, jums ir jāautentificē savs Instagram profils, noklikšķinot uz 'Turpināt ar Instagram' ",
        "ERROR_MESSAGE": "Veidojot savienojumu ar Instagram, radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "ERROR_AUTH": "Veidojot savienojumu ar Instagram, radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore."
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again"
      },
      "TWITTER": {
        "HELP": "Lai pievienotu savu Twitter profilu kā kanālu, Jums ir jāautentificē savs Twitter profils, noklikšķinot uz \"Pierakstīties ar Twitter\"' ",
        "ERROR_MESSAGE": "Radās kļūda, veidojot savienojumu ar Twitter. Lūdzu, mēģiniet vēlreiz",
        "TWEETS": {
          "ENABLE": "Izveidot sarunas no minētajiem Tvītiem"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Tīmekļa vietnes kanāls",
        "DESC": "Izveidot savai tīmekļa vietnei kanālu un sākt atbalstīt savus klientus, izmantojot mūsu tīmekļu vietnes logrīku.",
        "LOADING_MESSAGE": "Tiek Veikta Tīmekļa Vietnes Atbalsta Kanāla Izveide",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanāla Avatārs"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Lūdzu ievadiet Webhook URL",
          "ERROR": "Lūdzu, ievadiet derīgu URL"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Tīmekļa Vietnes Domēns",
          "PLACEHOLDER": "Ievadiet savas tīmekļa vietnes domēnu (piemēram: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Laipni lūdzam Virsraksts",
          "PLACEHOLDER": "Sveicināti !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Laipni lūdzam Teksts",
          "PLACEHOLDER": "Sazināties ar mums ir vienkārši. Vaicājiet mums jebko, vai dalieties ar savām atsauksmēm."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Kanāla sveiciena paziņojums",
          "PLACEHOLDER": "Acme Inc parasti atbild dažu stundu laikā."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Iespējot kanāla sveicienu",
          "HELP_TEXT": "Automātiski nosūtīt sveiciena paziņojumu, kad tiek izveidota jauna saruna.",
          "ENABLED": "Iespējots",
          "DISABLED": "Atspējots"
        },
        "REPLY_TIME": {
          "TITLE": "Iestatīt Atbildes laiku",
          "IN_A_FEW_MINUTES": "Dažās minutēs",
          "IN_A_FEW_HOURS": "Dažās stundās",
          "IN_A_DAY": "Dienas laikā",
          "HELP_TEXT": "Šis atbildes laiks tiks parādīts tiešsaistes tērzēšanas logrīkā"
        },
        "WIDGET_COLOR": {
          "LABEL": "Logrīka Krāsa",
          "PLACEHOLDER": "Atjaunināt logrīkā izmantoto logrīka krāsu"
        },
        "SUBMIT_BUTTON": "Izveidot iesūtni",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām izveidot tīmekļa vietnes kanālu. Lūdzu, mēģiniet vēlreiz"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Kanāls",
        "DESC": "Integrēt Twilio un sākt atbalstīt savus klientus, izmantojot SMS vai WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Konta SID",
          "PLACEHOLDER": "Lūdzu, ievadiet sava Twilio konta SID",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "API_KEY": {
          "USE_API_KEY": "Izmantot API Atslēgas Autentifikāciju",
          "LABEL": "API Atslēgas SID",
          "PLACEHOLDER": "Lūdzu, ievadiet savu API Atslēgas SID",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Atslēgas Noslēpums",
          "PLACEHOLDER": "Lūdzu, ievadiet savu API Atslēgas Noslēpumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Ziņapmaiņas Pakalpojuma SID",
          "PLACEHOLDER": "Lūdzu, ievadiet savu Twilio ziņojumapmaiņas pakalpojuma SID",
          "ERROR": "Šis lauks ir nepieciešams",
          "USE_MESSAGING_SERVICE": "Izmantot Twilio Ziņojumapmaiņas Pakalpojumu"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanāla Tips",
          "ERROR": "Lūdzu, izvēlieties sava Kanāla Tipu"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Lūdzu, ievadiet savu Twilio Auth Token",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "CHANNEL_NAME": {
          "LABEL": "Iesūtnes Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet iesūtnes nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefona numurs",
          "PLACEHOLDER": "Lūdzu, ievadiet tālruņa numuru, no kura tiks nosūtīts ziņojums.",
          "ERROR": "Lūdzu, norādiet derīgu tālruņa numuru, kas sākas ar zīmi “+” un nesatur atstarpes."
        },
        "API_CALLBACK": {
          "TITLE": "Atzvanīšanas URL",
          "SUBTITLE": "Jums ir jānokonfigurē Twilio pakalpojumā ziņojumu atzvanīšanas URL, izmantojot šeit minēto URL."
        },
        "SUBMIT_BUTTON": "Izveidot Twilio Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām autentificēt Twilio akreditācijas datus. Lūdzu, mēģiniet vēlreiz"
        }
      },
      "SMS": {
        "TITLE": "SMS Kanāls",
        "DESC": "Sāciet atbalstīt savus klientus, izmantojot SMS.",
        "PROVIDERS": {
          "LABEL": "API Pakalpojumu Sniedzējs",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth"
        },
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt SMS kanālu"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Konta ID",
            "PLACEHOLDER": "Lūdzu, ievadiet savu Bandwidth konta ID",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "API_KEY": {
            "LABEL": "API atslēga",
            "PLACEHOLDER": "Lūdzu ievadiet Bandwidth API Key",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Lūdzu ievadiet Bandwidth API Secret",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "APPLICATION_ID": {
            "LABEL": "Lietojumprogrammas ID",
            "PLACEHOLDER": "Lūdzu, ievadiet savu Bandwidth lietojumprogrammas ID",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "INBOX_NAME": {
            "LABEL": "Iesūtnes Nosaukums",
            "PLACEHOLDER": "Lūdzu, ievadiet iesūtnes nosaukumu",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "PHONE_NUMBER": {
            "LABEL": "Tālruņa numurs",
            "PLACEHOLDER": "Lūdzu, ievadiet tālruņa numuru, no kura tiks nosūtīts ziņojums.",
            "ERROR": "Lūdzu, norādiet derīgu tālruņa numuru, kas sākas ar zīmi “+” un nesatur atstarpes."
          },
          "SUBMIT_BUTTON": "Izveidot Bandwidth kanālu",
          "API": {
            "ERROR_MESSAGE": "Mēs nevarējām autentificēt Bandwidth akreditācijas datus. Lūdzu, mēģiniet vēlreiz"
          },
          "API_CALLBACK": {
            "TITLE": "Atzvanīšanas URL",
            "SUBTITLE": "Jums ir jānokonfigurē Bandwidth ziņojumu atzvanīšanas URL, izmantojot šeit minēto URL."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "WhatsApp Kanāls",
        "DESC": "Sāciet atbalstīt savus klientus, izmantojot WhatsApp.",
        "PROVIDERS": {
          "LABEL": "API Pakalpojumu Sniedzējs",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "Iesūtnes Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet iesūtnes nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "PHONE_NUMBER": {
          "LABEL": "Tālruņa numurs",
          "PLACEHOLDER": "Lūdzu, ievadiet tālruņa numuru, no kura tiks nosūtīts ziņojums.",
          "ERROR": "Lūdzu, norādiet derīgu tālruņa numuru, kas sākas ar zīmi “+” un nesatur atstarpes."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "Tālruņa numura ID",
          "PLACEHOLDER": "Lūdzu, ievadiet Tālruņa numura ID, kas iegūts no Facebook izstrādātāja informācijas paneļa.",
          "ERROR": "Lūdzu, ievadiet derīgu vērtību."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "Biznesa Konta ID",
          "PLACEHOLDER": "Lūdzu, ievadiet Biznesa Konta ID, kas iegūts no Facebook izstrādātāja informācijas paneļa.",
          "ERROR": "Lūdzu, ievadiet derīgu vērtību."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Webhook Pārbaudes Token",
          "PLACEHOLDER": "Ievadiet verifikācijas token, ko vēlaties izmantot priekš Facebook webhook.",
          "ERROR": "Lūdzu, ievadiet derīgu vērtību."
        },
        "API_KEY": {
          "LABEL": "API atslēga",
          "SUBTITLE": "Nokonfigurējiet WhatsApp API atslēgu.",
          "PLACEHOLDER": "API atslēga",
          "ERROR": "Lūdzu, ievadiet derīgu vērtību."
        },
        "API_CALLBACK": {
          "TITLE": "Atzvanīšanas URL",
          "SUBTITLE": "Jums Facebook izstrādātāju portālā ir jānokonfigurē webhoot URL un verifikācijas token ar tālāk norādītajām vērtībām.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verifikācijas Token"
        },
        "SUBMIT_BUTTON": "Izveidot WhatsApp kanālu",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt WhatsApp kanālu"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Telefona numurs",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "Konta SID",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Auth Token",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API Atslēgas SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "API Atslēgas Noslēpums",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Kanāls",
        "DESC": "Integrēt ar API kanālu un sākt atbalstīt savus klientus.",
        "CHANNEL_NAME": {
          "LABEL": "Kanāla Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet kanāla nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Konfigurēt URL, kurā vēlaties saņemt notikumu atzvanus.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Izveidot API kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt API kanālu"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-pasta Kanāls",
        "DESC": "Integrēt sava e-pasta iesūtni.",
        "CHANNEL_NAME": {
          "LABEL": "Kanāla Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet kanāla nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "EMAIL": {
          "LABEL": "E-pasts",
          "SUBTITLE": "Norādiet e-pasta adresi, uz kuru Jūsu klienti sūta atbalsta pieprasījumus.",
          "PLACEHOLDER": "E-pasts"
        },
        "SUBMIT_BUTTON": "Izveidot E-pasta Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt e-pasta kanālu"
        },
        "FINISH_MESSAGE": "Sākt pārsūtīt savus e-pasta ziņojumus uz tālāk norādīto e-pasta adresi.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Noklikšķiniet šeit",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Kanāls",
        "DESC": "Integrēt ar LINE kanālu un sākt atbalstīt savus klientus.",
        "CHANNEL_NAME": {
          "LABEL": "Kanāla Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet kanāla nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Kanāla ID",
          "PLACEHOLDER": "LINE Kanāla ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Kanāla Secret",
          "PLACEHOLDER": "LINE Kanāla Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Kanāla Token",
          "PLACEHOLDER": "LINE Kanāla Token"
        },
        "SUBMIT_BUTTON": "Izveidot LINE Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt LINE kanālu"
        },
        "API_CALLBACK": {
          "TITLE": "Atzvanīšanas URL",
          "SUBTITLE": "Jums LINE lietojumprogrammā ir jānokonfigurē webhook URL, ar šeit minēto URL."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Kanāls",
        "DESC": "Integrēt ar Telegram kanālu un sākt atbalstīt savus klientus.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Konfigurēt bot token, ko ieguvāt no Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Izveidot Telegram Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt Telegram kanālu"
        }
      },
      "AUTH": {
        "TITLE": "Izvēlieties kanālu",
        "DESC": "Chatwoot atbalsta tiešraides tērzēšanas logrīkus, Facebook Messenger, Twitter profilus, WhatsApp, e-pastus kā kanālus. Ja vēlaties izveidot pielāgotu kanālu, varat to izveidot, izmantojot API kanālu. Lai sāktu, izvēlieties vienu no tālāk norādītajiem kanāliem.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Gatavs!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Tīmekļa vietne",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "E-pasts",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Aģenti",
        "DESC": "Šeit Jūs varat pievienot aģentus, lai pārvaldītu savu jaunizveidoto iesūtni. Tikai šiem atlasītajiem aģentiem būs piekļuve Jūsu iesūtnei. Aģenti, kas neietilpst šajā iesūtnē, nevarēs redzēt ziņojumus vai atbildēt uz ziņojumiem šajā iesūtnē, kad būs pierakstījušies sistēmā. <br> <b>PS:</b> Ja jums kā administratoram ir nepieciešama piekļuve pie visām iesūtnēm, jums ir jāpievieno sevi kā aģentu visām izveidotajām iesūtnēm.",
        "VALIDATION_ERROR": "Pievienojiet savai jaunajai iesūtnei vismaz vienu aģentu",
        "PICK_AGENTS": "Izvēlieties aģentus priekš iesūtnes"
      },
      "DETAILS": {
        "TITLE": "Informācija par Iesūtni",
        "DESC": "Tālāk esošajā nolaižamajā izvēlnē izvēlieties Facebook lapu, kuru vēlaties savienot ar Chatwoot. Jūs varat savai iesūtnei, lai to labāk atpazītu, piešķirt pielāgotu nosaukumu."
      },
      "FINISH": {
        "TITLE": "Sanāca!",
        "DESC": "Jūs esat veiksmīgi pabeidzis savas Facebook lapas integrēšanu ar Chatwoot. Nākamreiz, kad klients nosūtīs ziņojumu Jūsu lapai, saruna automātiski parādīsies Jūsu iesūtnē.<br>Mēs nodrošinām Jums arī logrīka skriptu, ko varat viegli pievienot savai tīmekļa vietnei. Kad tas būs pieejams Jūsu vietnē, klienti varēs Jums nosūtīt ziņojumus tieši no Jūsu tīmekļa vietnes, neizmantojot ārējus rīkus, un saruna tiks parādīta tieši šeit, vietnē Chatwoot.<br>"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Izvēlieties savu e-pasta pakalpojumu sniedzēju",
        "DESCRIPTION": "Tālāk esošajā sarakstā izvēlieties e-pasta pakalpojumu sniedzēju. Ja sarakstā neredzat savu e-pasta pakalpojumu sniedzēju, varat izvēlēties citu pakalpojumu sniedzēja opciju un norādīt IMAP un SMTP akreditācijas datus."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Lai sāktu, noklikšķiniet uz pogas Pierakstīties ar Microsoft. Jūs tiksit novirzīts uz e-pasta pierakstīšanās lapu. Kad būsiet pieņēmis pieprasītās atļaujas, Jūs tiksit novirzīts atpakaļ uz iesūtnes izveides darbību.",
        "EMAIL_PLACEHOLDER": "Ievadiet e-pasta adresi",
        "SIGN_IN": "Pierakstīties ar Microsoft",
        "ERROR_MESSAGE": "Veidojot savienojumu ar Microsoft, radās kļūda. Lūdzu, mēģiniet vēlreiz"
      },
      "GOOGLE": {
        "TITLE": "Google e-pasts",
        "DESCRIPTION": "Lai sāktu, noklikšķiniet uz pogas Pierakstīties ar Google. Jūs tiksit novirzīts uz e-pasta pierakstīšanās lapu. Kad būsiet pieņēmis pieprasītās atļaujas, jūs tiksit novirzīts atpakaļ uz iesūtnes izveides darbību.",
        "SIGN_IN": "Pierakstīties ar Google",
        "EMAIL_PLACEHOLDER": "Ievadiet e-pasta adresi",
        "ERROR_MESSAGE": "Veidojot savienojumu ar Google, radās kļūda. Lūdzu, mēģiniet vēlreiz"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Notiek Jūsu autentificēšana, izmantojot Facebook...",
      "ERROR_FB_LOADING": "Ielādējot Facebook SDK, radās kļūda. Lūdzu, atspējojiet visus reklāmu bloķētājus un mēģiniet vēlreiz no citas pārlūkprogrammas.",
      "ERROR_FB_AUTH": "Radās kļūda. Lūdzu, atsvaidziniet lapu...",
      "ERROR_FB_UNAUTHORIZED": "Jums nav tiesību veikt šo darbību. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Lūdzu, pārliecinieties, ka Jums ir pilna piekļuve Facebook lapai. Vairāk par Facebook lomām varat lasīt <a href=\" https://www.facebook.com/help/187316341316631\">šeit</a>.",
      "CREATING_CHANNEL": "Notiek Iesūtnes izveide...",
      "TITLE": "Nokonfigurēt Iesūtnes Informāciju",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Pievienot aģentus",
      "ADD_AGENTS": "Notiek aģentu pievienošana Jūsu iesūtnei..."
    },
    "FINISH": {
      "TITLE": "Jūsu Iesūtne ir gatava!",
      "MESSAGE": "Tagad Jūs varat izmantot savu jauno Kanālu lai sazinātos ar saviem klientiem. Priecīgu atbalstīšanu",
      "BUTTON_TEXT": "Iet uz",
      "MORE_SETTINGS": "Papildu iestatījumi",
      "WEBSITE_SUCCESS": "Jūs esat veiksmīgi pabeidzis tīmekļa vietnes kanāla izveidi. Nokopējiet tālāk redzamo kodu un ievietojiet to savā tīmekļa vietnē. Nākamreiz, kad klients izmantos tiešsaistes tērzēšanu, saruna automātiski tiks parādīta Jūsu iesūtnē.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "Atkārtoti autorizēties",
    "VIEW": "Apskatīt",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Iesūtnes iestatījumi ir veiksmīgi atjaunināti",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automātiskā piešķiršana ir veiksmīgi atjaunināta",
        "ERROR_MESSAGE": "Mēs nevarējām atjaunināt iesūtnes iestatījumus. Lūdzu, vēlāk pamēģiniet vēlreiz."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sūtītāja vārds",
        "SUB_TEXT": "Izvēlieties vārdu, kas tiks rādīts jūsu klientam, saņemot e-pasta ziņojumus no jūsu aģentiem.",
        "FOR_EG": "Piemēram:",
        "FRIENDLY": {
          "TITLE": "Draudzīgs",
          "FROM": "no",
          "SUBTITLE": "Sūtītāja vārdā pievienojiet tā aģenta vārdu, kurš nosūtīja atbildi, lai atbilde būtu draudzīga."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesionāls",
          "SUBTITLE": "Izmantot tikai konfigurēto uzņēmuma nosaukumu kā sūtītāja vārdu e-pasta galvenē."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Konfigurēt uzņēmuma nosaukumu",
          "PLACEHOLDER": "Ievadiet uzņēmuma nosaukumu",
          "SAVE_BUTTON_TEXT": "Saglabāt"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Iespējot"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Dzēst",
      "AVATAR_DELETE_BUTTON_TEXT": "Dzēst Avatāru",
      "CONFIRM": {
        "TITLE": "Apstiprināt Dzēšanu",
        "MESSAGE": "Vai vēlaties izdzēst ",
        "PLACE_HOLDER": "Lūdzu, uzrakstiet {inboxName} lai apstiprinātu",
        "YES": "Jā, Dzēst ",
        "NO": "Nē, Paturēt "
      },
      "API": {
        "SUCCESS_MESSAGE": "Iesūtne veiksmīgi izdzēsta",
        "ERROR_MESSAGE": "Nevarēja izdzēst iesūtni. Lūdzu, vēlāk pamēģiniet vēlreiz.",
        "AVATAR_SUCCESS_MESSAGE": "Iesūtnes avatārs ir veiksmīgi izdzēsts",
        "AVATAR_ERROR_MESSAGE": "Nevarēja izdzēst iesūtnes avatāru. Lūdzu, vēlāk pamēģiniet vēlreiz."
      }
    },
    "TABS": {
      "SETTINGS": "Iestatījumi",
      "COLLABORATORS": "Līdzstrādnieki",
      "CONFIGURATION": "Konfigurācija",
      "CAMPAIGN": "Kampaņas",
      "PRE_CHAT_FORM": "Pirms-Tērzēšanas Veidlapa",
      "BUSINESS_HOURS": "Darba Laiks",
      "WIDGET_BUILDER": "Logrīku Veidotājs",
      "BOT_CONFIGURATION": "Robota Konfigurācija",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "CSAT",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Apstiprināts",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "Tiešraide"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Iestatījumi",
    "FEATURES": {
      "LABEL": "Īpašības",
      "DISPLAY_FILE_PICKER": "Logrīkā parādīt failu atlasītāju",
      "DISPLAY_EMOJI_PICKER": "Logrīkā parādīt emocijzīmju atlasītāju",
      "ALLOW_END_CONVERSATION": "Atļaut lietotājiem beigt sarunu no logrīka",
      "USE_INBOX_AVATAR_FOR_BOT": "Izmantot iesūtnes nosaukumu un avataru priekš robota"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Skripts",
      "MESSENGER_SUB_HEAD": "Ievietojiet šo pogu savā body tagā",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Aģenti",
      "INBOX_AGENTS_SUB_TEXT": "Pievienot vai noņemt aģentus no šīs iesūtnes",
      "AGENT_ASSIGNMENT": "Sarunas Piešķiršana",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Atjaunināt sarunas piešķiršanas iestatījumus",
      "UPDATE": "Atjaunināt",
      "ENABLE_EMAIL_COLLECT_BOX": "Iespējot e-pasta iegūšanas lodziņu",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Iespējot vai atspējot e-pasta iegūšanas lodziņu jaunai sarunai",
      "AUTO_ASSIGNMENT": "Iespējot automātisko piešķiršanu",
      "SENDER_NAME_SECTION": "Iespējot Aģenta Vārdu E-pastā",
      "SENDER_NAME_SECTION_TEXT": "Iespējot/Atspējot aģenta vārda rādīšanu e-pastā. Ja tas ir atspējots, tiks rādīts uzņēmuma nosaukums",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Iespējot sarunas nepārtrauktību, izmantojot e-pastu",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Sarunas turpināsies pa e-pastu, ja saziņas e-pasta adrese ir pieejama.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Iesūtnes Iestatījumi",
      "INBOX_UPDATE_SUB_TEXT": "Atjaunināt Jūsu iesūtnes iestatījumus",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Iespējot vai atspējot jaunu sarunu automātisku piešķiršanu šai iesūtnei pievienotajiem aģentiem.",
      "HMAC_VERIFICATION": "Lietotāja Identitātes Apstiprināšana",
      "HMAC_DESCRIPTION": "Izmantojot šo atslēgu, varat ģenerēt slepeno marķieri, ko var izmantot, lai pārbaudītu Jūsu lietotāju identitāti.",
      "HMAC_LINK_TO_DOCS": "Papildu informācija ir pieejama šeit.",
      "HMAC_MANDATORY_VERIFICATION": "Īstenot Lietotāja Identitātes Validāciju",
      "HMAC_MANDATORY_DESCRIPTION": "Ja iespējots, pieprasījumi, kurus nevar pārbaudīt, tiks noraidīti.",
      "INBOX_IDENTIFIER": "Iesūtnes identifikators",
      "INBOX_IDENTIFIER_SUB_TEXT": "Izmantojiet šeit uzrādīto `inbox_identifier` token, lai autentificētu savus API klientus.",
      "FORWARD_EMAIL_TITLE": "Pārsūtīt uz E-pastu",
      "FORWARD_EMAIL_SUB_TEXT": "Sākt pārsūtīt savus e-pasta ziņojumus uz tālāk norādīto e-pasta adresi.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Atļaut ziņojumus pēc sarunas pabeigšanas",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Ļaut galalietotājiem sūtīt ziņojumus pat pēc sarunas atrisināšanas.",
      "WHATSAPP_SECTION_SUBHEADER": "Šī API atslēga tiek izmantota integrācijai ar WhatsApp API.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Ievadiet jauno API atslēgu, kas tiks izmantota integrācijai ar WhatsApp API.",
      "WHATSAPP_SECTION_TITLE": "API atslēga",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Atjaunināt API atslēgu",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Ievadiet šeit jauno API atslēgu",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Atjaunināt",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "Savienot",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Webhook Verifikācijas Token",
      "WHATSAPP_WEBHOOK_SUBHEADER": "Šis marķieris tiek izmantots, lai pārbaudītu webhook endpoint autentiskumu.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Atjaunināt pirms-tērzēšanas veidlapas iestatījumus"
    },
    "HELP_CENTER": {
      "LABEL": "Palīdzības centrs",
      "PLACEHOLDER": "Izvēlēties Palīdzības Centru",
      "SELECT_PLACEHOLDER": "Izvēlēties Palīdzības Centru",
      "NONE": "Nav",
      "REMOVE": "Noņemt Palīdzības Centru",
      "SUB_TEXT": "Pievienot Palīdzības Centru ar iesūtni"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Automātiskās piešķiršanas ierobežojums",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Lūdzu, ievadiet vērtību, kas ir lielāka par 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Ierobežo maksimālo sarunu skaitu no šīs iesūtnes, ko var automātiski piešķirt aģentam"
    },
    "ASSIGNMENT": {
      "TITLE": "Sarunas Piešķiršana",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Aktīvs",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "Atcelt",
      "CONFIRM_DELETE": "Dzēst",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Atkārtoti autorizēties",
      "SUBTITLE": "Jūsu Facebook savienojuma derīguma termiņš ir beidzies. Lūdzu, atkārtoti pievienojiet savu Facebook lapu, lai turpinātu pakalpojumus",
      "MESSAGE_SUCCESS": "Atkārtota savienojuma izveide ir veiksmīga",
      "MESSAGE_ERROR": "Radās kļūda. Lūdzu, mēģiniet vēlreiz"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pirms tērzēšanas veidlapas ļauj iegūt informāciju par lietotājiem, pirms viņi sāk ar Jums sarunu.",
      "SET_FIELDS": "Pirms tērzēšanas veidlapas lauki",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Lauki",
        "LABEL": "Etiķete",
        "PLACE_HOLDER": "Vietturis",
        "KEY": "Atslēga",
        "TYPE": "Tips",
        "REQUIRED": "Nepieciešams"
      },
      "ENABLE": {
        "LABEL": "Iespējot pirms tērzēšanas veidlapu",
        "OPTIONS": {
          "ENABLED": "Jā",
          "DISABLED": "Nē"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pirms tērzēšanas ziņojums",
        "PLACEHOLDER": "Šis ziņojums būs redzams lietotājiem, kopā ar veidlapu"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Apmeklētājiem pirms tērzēšanas ir jānorāda savs vārds un e-pasta adrese"
      }
    },
    "CSAT": {
      "TITLE": "Iespējot CSAT",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "Ziņojums",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Valoda",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "Atgriezties"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "satur",
          "DOES_NOT_CONTAINS": "nesatur"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Iestatīt savu pieejamību",
      "SUBTITLE": "Iestatīt savu pieejamību tiešraides tērzēšanas logrīkā",
      "WEEKLY_TITLE": "Iestatīt savu darba laiku",
      "TIMEZONE_LABEL": "Izvēlieties laika joslu",
      "UPDATE": "Atjaunināt darba laika iestatījumus",
      "TOGGLE_AVAILABILITY": "Iespējot biznesa pieejamību šai iesūtnei",
      "UNAVAILABLE_MESSAGE_LABEL": "Ziņojums nav pieejams priekš apmeklētājiem",
      "TOGGLE_HELP": "Iespējojot uzņēmuma pieejamību, tiešraides tērzēšanas logrīkā tiks rādīts darba laiks, pat ja visi aģenti būs bezsaistē. Ārpus darba laika apmeklētājus var brīdināt ar ziņojumu un pirms tērzēšanas veidlapu.",
      "DAY": {
        "DAY": "Diena",
        "AVAILABILITY": "Pieejamība",
        "HOURS": "Hours",
        "ENABLE": "Iespējot pieejamību šai dienai",
        "UNAVAILABLE": "Nav pieejams",
        "VALIDATION_ERROR": "Sākuma laikam jābūt pirms slēgšanas laika.",
        "CHOOSE": "Izvēlēties"
      },
      "ALL_DAY": "Visu dienu"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Iestatīt IMAP informāciju",
      "NOTE_TEXT": "Lai iespējotu SMTP, lūdzu, nokonfigurējiet IMAP.",
      "UPDATE": "Atjaunināt IMAP iestatījumus",
      "TOGGLE_AVAILABILITY": "Iespējot IMAP konfigurāciju šai iesūtnei",
      "TOGGLE_HELP": "Iespējojot IMAP, lietotājs varēs saņemt e-pastu",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP iestatījumi ir veiksmīgi atjaunināti",
        "ERROR_MESSAGE": "Nevar atjaunināt IMAP iestatījumus"
      },
      "ADDRESS": {
        "LABEL": "Adrese",
        "PLACE_HOLDER": "Adrese (piemēram: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Ports",
        "PLACE_HOLDER": "Ports"
      },
      "LOGIN": {
        "LABEL": "Lietotājvārds",
        "PLACE_HOLDER": "Lietotājvārds"
      },
      "PASSWORD": {
        "LABEL": "Parole",
        "PLACE_HOLDER": "Parole"
      },
      "ENABLE_SSL": "Iespējot SSL",
      "AUTH_MECHANISM": "Autentifikācija"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Atkārtoti autorizēt savu MICROSOFT kontu"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Iestatīt SMTP informāciju",
      "UPDATE": "Atjaunināt SMTP iestatījumus",
      "TOGGLE_AVAILABILITY": "Iespējot SMTP konfigurāciju šai iesūtnei",
      "TOGGLE_HELP": "Iespējojot SMTP lietotājs varēs nosūtīt e-pastu",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP iestatījumi ir veiksmīgi atjaunināti",
        "ERROR_MESSAGE": "Nevar atjaunināt SMTP iestatījumus"
      },
      "ADDRESS": {
        "LABEL": "Adrese",
        "PLACE_HOLDER": "Adrese (piemēram: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Ports",
        "PLACE_HOLDER": "Ports"
      },
      "LOGIN": {
        "LABEL": "Lietotājvārds",
        "PLACE_HOLDER": "Lietotājvārds"
      },
      "PASSWORD": {
        "LABEL": "Parole",
        "PLACE_HOLDER": "Parole"
      },
      "DOMAIN": {
        "LABEL": "Domēns",
        "PLACE_HOLDER": "Domēns"
      },
      "ENCRYPTION": "Šifrēšana",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Režīms",
      "AUTH_MECHANISM": "Autentifikācija"
    },
    "NOTE": "Piezīme: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Tīmekļa Vietnes Avatārs",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatārs ir veiksmīgi izdzēsts",
              "ERROR_MESSAGE": "Radās kļūda. Lūdzu, mēģiniet vēlreiz"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Tīmekļa Vietnes Nosaukums",
          "PLACE_HOLDER": "Ievadiet Jūsu tīmekļa vietnes nosaukumu (piemēram: Acme Inc)",
          "ERROR": "Lūdzu, ievadiet derīgu tīmekļa vietnes nosaukumu"
        },
        "WELCOME_HEADING": {
          "LABEL": "Laipni lūdzam Virsraksts",
          "PLACE_HOLDER": "Sveicināti!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Laipni lūdzam Teksts",
          "PLACE_HOLDER": "Sazināties ar mums ir vienkārši. Vaicājiet mums jebko, vai dalieties ar savām atsauksmēm."
        },
        "REPLY_TIME": {
          "LABEL": "Atbildes Laiks",
          "IN_A_FEW_MINUTES": "Dažās minutēs",
          "IN_A_FEW_HOURS": "Dažās stundās",
          "IN_A_DAY": "Dienas laikā"
        },
        "WIDGET_COLOR_LABEL": "Logrīka Krāsa",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Tips:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Tērzējiet ar mums",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Tērzējiet ar mums"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Atjaunināt Logrīka Iestatījumus",
          "API": {
            "SUCCESS_MESSAGE": "Logrīka iestatījumi ir veiksmīgi atjaunināti",
            "ERROR_MESSAGE": "Nevar atjaunināt logrīka iestatījumus"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Priekšskatījums",
          "SCRIPT": "Skripts"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Pa kreisi",
          "RIGHT": "Pa labi"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standarta",
          "EXPANDED_BUBBLE": "Izvērsts Burbulis"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Noklusējums",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Parasti atbild dažu minūšu laikā",
        "IN_A_FEW_HOURS": "Parasti atbild dažu stundu laikā",
        "IN_A_DAY": "Parasti atbild vienas dienas laikā"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Sākt Sarunu",
        "CHAT_INPUT_PLACEHOLDER": "Rakstiet savu ziņojumu"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Mēs esam Tiešsaistē",
          "OFFLINE": "Šobrīd neesam uz vietas"
        },
        "USER_MESSAGE": "Sveicināti",
        "AGENT_MESSAGE": "Labdien"
      },
      "BRANDING_TEXT": "Darbināts ar Chatwoot",
      "SCRIPT_SETTINGS": "\nwindow.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Citi Pakalpojuma Sniedzēji",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Tīmekļa vietne",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-pasts",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Kanāls",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
